<template>
    <div class="page">
        <box>
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5" v-if="!mainSearch.query.fcCode">
                    <el-form-item label="生产组织" class="EL-Form-Item">
                        <el-select v-model="mainSearch.query.fcCode" placeholder="请选择" clearable="clearable">
                            <el-option label="DLM大连一厂" value="DLM" />
                            <el-option label="DLN大连二厂" value="DLN" />
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearch.query.whCode" filterable  placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in WhCodeList" :key="item.whId" :label="item.whCode + '-' + item.whName" :value="item.whCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.matCode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料描述" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.matName" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item" v-if="mainSearch.query.fcCode">
                        <el-select v-model="mainSearch.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode">
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="inquireDataClick('mainSearch')">
                            查询
                        </el-button>
                        <el-button class="btn-t-delete" @click="resetClick('mainSearch')">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item" v-if="!mainSearch.query.fcCode">
                        <el-select v-model="mainSearch.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode">
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="批次号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.batchNo" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装编号" class="EL-Form-Item">
                        <el-input v-model="mainSearch.query.boxBarcode" placeholder="请输入"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearch.query.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
        </box>
        <box fill>
            <plabel text="库存列表">
                <el-button v-authority="'BACK_MENU3_M16_B6'" class="btn-t-edit" @click="rpReceipt()">RP收货</el-button>
                <el-button v-authority="'BACK_MENU3_M16_B1'" class="btn-t-edit" @click="insertOpenRecord()">交易调整记录</el-button>
                <el-button v-authority="'BACK_MENU3_M16_B2'" class="btn-t-edit" @click="insertOpenNew()">新增交易</el-button>
                <el-button v-authority="'BACK_MENU3_M16_B3'" class="btn-t-edit" @click="insertOpen()">交易调整</el-button>
                <el-button v-authority="'BACK_MENU3_M16_B4'" @click="printBarcode()" class="btn-t-edit">标签打印</el-button>
                <el-button v-authority="'BACK_MENU3_M16_B5'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFile()">导出EXCEL</el-button>
            </plabel>
            <h-table   :summaryMethod="getSummaries" show-summary   :headerCellStyle="mainSearch.headerCellStyle" style="flex: 1" @pageChange="getTableData" :data="mainSearch.data" pagination :nowPage.sync="mainSearch.pageNum" :pageSize.sync="mainSearch.pageSize" :total.sync="mainSearch.total" @selectionChange="selectRepertory">/
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="通道编号" prop="whCode" align="center" min-width="100">
                </el-table-column>
                <el-table-column label="物料编号" prop="matCode" align="center" min-width="100">
                </el-table-column>
                <el-table-column label="物料描述" prop="matName" align="center" min-width="100">
                </el-table-column>
                <el-table-column label="数量" prop="matQuan" align="center">
                </el-table-column>
                <el-table-column label="物料状态" align="center" width="80px">
                  <template slot-scope="scope">
                    <span v-if="scope.row.wiStatus == 'NORMAL'">正常</span>
                    <span v-if="scope.row.wiStatus == 'FREEZE'">拣配中</span>
                    <span v-if="scope.row.wiStatus == 'AGFREEZE'">冻结</span>
                  </template>
                </el-table-column>
                <el-table-column label="质检状态" align="center" width="80px">
                  <template slot-scope="scope">
                    <span v-if="scope.row.checkResult == '10'">待检</span>
                    <span v-if="scope.row.checkResult == '20'">合格</span>
                    <span v-if="scope.row.checkResult == '30'">不合格</span>
                    <span v-if="scope.row.checkResult == '40'">退货</span>
                  </template>
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime" :formatter="dateFormat"  min-width="130"></el-table-column>
                <el-table-column label="批次号" prop="batchNo" align="center">
                </el-table-column>
                <el-table-column label="库位" prop="lcCode" align="center">
                </el-table-column>
                <el-table-column label="包装箱号" prop="boxBarcode" align="center" min-width="100">
                </el-table-column>
                <el-table-column label="订单编号" prop="orderCode" align="center" min-width="100">
                </el-table-column>
                <el-table-column label="规值" prop="matSpecs" align="center">
                </el-table-column>
                <el-table-column label="热处理批号" align="center" prop="heatNumber" min-width="100"></el-table-column>
                <el-table-column label="钢材炉号" align="center" prop="heatNo"></el-table-column>

                <el-table-column label="收货人" align="center" prop="consignee"></el-table-column>


                <el-table-column label="仓库类型" align="center" width="120px">
                  <template slot-scope="scope">
                    {{ scope.row.saleFlag ? '寄售仓' : '非寄售仓' }}
                  </template>
                </el-table-column>
                <el-table-column label="原箱号" align="center" width="120px">
                  <template slot-scope="scope">
                    {{ scope.row.oldBoxBarcode != null? scope.row.oldBoxBarcode : scope.row.boxBarcode }}
                  </template>
                </el-table-column>
                <el-table-column label="供应商" align="center" width="120px" prop="verdorCode">
                </el-table-column>
                <el-table-column label="供应商名称" align="center" width="120px" prop="svName">
                </el-table-column>
                <el-table-column label="备注" align="center" prop="remark"></el-table-column>

            </h-table>
        </box>
        <!-- 交易调整记录 -->
        <el-dialog title="交易调整记录" :visible.sync="mainSearcRecord.insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false">
            <el-form label-position="right" label-width="80px" class="EL-Form">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道编号" class="EL-Form-Item">
                        <el-select v-model="mainSearcRecord.query.whCode" placeholder="请选择" clearable="clearable">
                            <el-option v-for="item in WhCodeList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName">{{item.whCode}}-{{item.whName}}</el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" class="EL-Form-Item">
                        <el-input v-model="mainSearcRecord.query.matCode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料批次" class="EL-Form-Item">
                        <el-input v-model="mainSearcRecord.query.batchNo" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="mainSearcRecord.query.fcCode">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearcRecord.query.boxBarcode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>

                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getOtherRecordList()">查询</el-button>
                        <el-button class="btn-t-delete" @click="resetClick('mainSearcRecord')">重置</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5" v-if="!mainSearcRecord.query.fcCode">
                    <el-form-item label="包装箱号" class="EL-Form-Item">
                        <el-input v-model="mainSearcRecord.query.boxBarcode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="交易类型" class="EL-Form-Item">
                        <el-select v-model="mainSearcRecord.query.sorTypeSub" clearable="clearable" placeholder="请选择">
                          <el-option key="10" value="IA" label="IA"></el-option>
                          <!-- <el-option key="60" value="RW" label="RW"></el-option> -->
                            <!-- <el-option key="70" value="IW" label="IW"></el-option>-->
                            <el-option key="20" value="IS" label="IS"></el-option>
                            <el-option key="30" value="SS" label="SS"></el-option>
                            <!-- <el-option key="40" value="VR" label="VR"></el-option>
                            <el-option key="50" value="RP" label="RP"></el-option>
                            <el-option key="70" value="RI" label="RI"></el-option> -->
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="规值" class="EL-Form-Item">
                        <el-input v-model="mainSearcRecord.query.matSpecs" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="操作人" class="EL-Form-Item">
                        <el-input v-model="mainSearcRecord.query.person" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="开始日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearcRecord.query.date[0]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="开始日期" :picker-options="startPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="结束日期" class="EL-Form-Item">
                        <el-date-picker v-model="mainSearcRecord.query.date[1]" value-format="yyyy-MM-dd HH:mm" type="date" placeholder="结束日期" :picker-options="finishPickerOptions"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form>
            <div class="dao">
                 <el-button v-authority="'BACK_MENU3_M16_B5'" :loading="downloadLoading" class="btn-t-edit" type="primary" @click="downLoadFiles()">导出EXCEL</el-button>
           </div>
            <h-table :headerCellStyle="mainSearcRecord.headerCellStyle" :style="$popups.harvestRecordStyle(0.60)" @pageChange="getOtherRecordList()" :data="mainSearcRecord.data" pagination :nowPage.sync="mainSearcRecord.pageNum" :pageSize.sync="mainSearcRecord.pageSize" :total.sync="mainSearcRecord.total"  @selectionChange="selectAdjustment">
                <el-table-column type="selection" align="center"> </el-table-column>
                <el-table-column label="通道编号" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="交易单号" align="center" prop="sorCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="物料数量" align="center" prop="beforeMatQuan">
                </el-table-column>
                <el-table-column label="调整数量" align="center" prop="matQuan">
                    <template slot-scope="scope">
                        <div v-if="scope.row.sorTypeSub == 'IA' || scope.row.sorTypeSub == 'RW' ||
                        scope.row.sorTypeSub == 'RP'">{{scope.row.matQuan - scope.row.beforeMatQuan}}</div>

                        <div v-if="scope.row.sorTypeSub == 'IW' || scope.row.sorTypeSub == 'SS' ||
                        scope.row.sorTypeSub == 'IS' || scope.row.sorTypeSub == 'VR'">{{scope.row.beforeMatQuan - scope.row.matQuan}}</div>
                    </template>
                </el-table-column>
                <el-table-column label="物料批次" align="center" prop="batchNo">
                </el-table-column>
                <!-- <el-table-column label="入库库区" align="center" prop="whArea">
                </el-table-column> -->
                <el-table-column label="库位" align="center" prop="laCode">
                </el-table-column>
                <el-table-column label="包装编号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="交易类型" align="center" prop="sorTypeSub">
                    <template slot-scope="scope">
                        <span v-if="scope.row.sorTypeSub == 'IA'">IA</span>
                        <span v-if="scope.row.sorTypeSub == 'IS'">IS</span>
                        <span v-if="scope.row.sorTypeSub == 'SS'">SS</span>
                        <!-- <span v-if="scope.row.sorTypeSub == 'IW'">IW</span>
                        <span v-if="scope.row.sorTypeSub == 'RW'">RW</span> -->
                        <span v-if="scope.row.sorTypeSub == 'VR'">VR</span>
                        <span v-if="scope.row.sorTypeSub == 'RP'">RP</span>
                        <!-- <span v-if="scope.row.sorTypeSub == 'RI'">RI</span> -->
                    </template>
                </el-table-column>
                <el-table-column label="操作时间" align="center" prop="createTime">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs">
                </el-table-column>
                <el-table-column label="操作人" align="center" prop="person">
                </el-table-column>
                <el-table-column label="申请人" align="center" prop="personCost">
                </el-table-column>
              <el-table-column label="成本中心" align="center" prop="reasonCode">
              </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" @click="closeDialogClick('mainSearcRecord')" type="info">关闭</el-button>
            </div>
        </el-dialog>
        <!-- 交易详情 -->
        <el-dialog title="交易详情" :visible.sync="mainObj.insertShowRecord" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false">
            <el-form label-position="right" label-width="100px" :model="mainObj.query" ref="mainObj">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="交易类型" prop="sorTypeSub" class="EL-Form-Item">
                        <el-select v-model="mainObj.query.sorTypeSub" clearable="clearable" placeholder="请选择" @change="getTransaction">
                            <el-option value="IA" label="IA"></el-option>
                            <!-- <el-option value="IW" label="IW" v-if="roleCode == 'LEVEL_1' || roleCode == 'LEVEL_2'"></el-option>
                            <el-option value="RW" label="RW" v-if="roleCode == 'LEVEL_1' || roleCode == 'LEVEL_2'"></el-option> -->
                            <el-option value="IS" label="IS"></el-option>
                            <el-option value="SS" label="SS" ></el-option>
                            <!-- <el-option value="VR" label="VR" v-if="roleCode == 'LEVEL_1' || roleCode == 'LEVEL_2'"></el-option>
                            <el-option value="RP" label="RP" v-if="roleCode == 'LEVEL_1' || roleCode == 'LEVEL_2'"></el-option>
                            <el-option value="RI" label="RI" v-if="roleCode == 'LEVEL_1' || roleCode == 'LEVEL_2'"></el-option>-->
                        </el-select>
                    </el-form-item>
                </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="人员" prop="personcost" class="EL-Form-Item">
                  <el-select v-model="mainObj.query.personcost" clearable="clearable" filterable placeholder="请选择" @change="getCost($event)" >
                    <el-option :value="item.person" :label="item.person +'-'+ item.cost" :key="index" v-for="(item, index) in personCost"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="成本中心" prop="sorTypeSub" class="EL-Form-Item">
                        <el-select v-model="mainObj.query.reasonCode" clearable="clearable" filterable placeholder="请选择" >
                            <el-option :value="item.reasonCode" :label="item.reasonCode +'-'+ item.reasonDescription" :key="index" v-for="(item, index) in transationReasonData"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="2" :xl="2" :offset="8">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="insertTran">
                            新增交易
                        </el-button>
                    </el-form-item>
                </el-col> -->
                <el-col :lg="4" :xl="4" :offset="10">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="rePrintBarcode()">
                            标签打印
                        </el-button>
                    </el-form-item>
                </el-col>
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                        <el-select v-model="mainObj.query.matCode" filterable :clearable="true" remote :remote-method="remoteMethod" @change="remoteMethod">
                            <el-option v-for="item in this.materialList" :key="item.mtId" :label="item.mtCode" :value="item.mtCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :lg="5" :xl="5">
                    <el-form-item label="库位" class="EL-Form-Item">
                        <el-select v-model="mainObj.query.lcCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCode">
                            <el-option v-for="(item, index) in lcCodeList" :key="index" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="包装编号" prop="boxBarcode" class="EL-Form-Item">
                        <el-input v-model="mainObj.query.boxBarcode" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col> -->
                <!-- <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="getWhData()">查询</el-button>
                    </el-form-item>
                </el-col> -->
            </el-form>
            <!-- <h-table :style="$popups.harvestRecordStyle(0.71)" @pageChange="getWhData" :data="mainObj.data" pagination :nowPage.sync="mainObj.pageNum" :pageSize.sync="mainObj.pageSize" :total.sync="mainObj.total" @selectionChange="selectAll"> -->
            <h-table :style="$popups.harvestRecordStyle(0.65)" :data="mainObj.data" @selectionChange="selectAll">
                <el-table-column type="selection" align="center" fixed="left"></el-table-column>
                <el-table-column label="通道" align="center" prop="whCode">
                </el-table-column>
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="调整物料" align="center" prop="matCode" width="150px">
                    <template slot-scope="scope">
                        <el-input v-if="mainObj.query.sorTypeSub == 'IA'" v-model="scope.row.newMatCode" size="mini"></el-input>
                        <el-input v-else disabled v-model="scope.row.newMatCode" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="库存数量" align="center" prop="beforeMatQuan">
                </el-table-column>
                <el-table-column label="调整数量" align="center" prop="matQuan" width="150px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.adjustMatQuan" style="width: 100%;line-height: 26px !important" size="mini"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo" width="150px">
                </el-table-column>
                <el-table-column label="调整规值" align="center" width="150px">
                    <template slot-scope="scope">
                        <el-input v-if="mainObj.query.sorTypeSub == 'IA'" v-model="scope.row.newBatchNo" size="mini"></el-input>
                        <el-input v-else disabled v-model="scope.row.batchNo" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="库位" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.laCode || scope.row.lcCode }}
                    </template>
                </el-table-column>
                <el-table-column label="包装箱号" align="center" prop="boxBarcode">
                </el-table-column>
                <el-table-column label="规值" align="center" prop="matSpecs" width="70px">
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime">
                </el-table-column>
                <!-- <el-table-column label="库区" align="center" prop="whArea">
                </el-table-column> -->
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" type="info" @click="closeDialogClick('mainObj')">取 消</el-button>
                <el-button size="mini" class="btn-t-edit" @click="saveOtherOut()">确 认</el-button>
            </div>
        </el-dialog>

        <!-- 库存详情 -->
        <el-dialog title="库存详情" :visible.sync="insertShowNew" class="fromDialog" :style="$popups.popups(0.8,0.9)" :close-on-click-modal="false" :show-close="false" :model="mainObj">
            <el-form label-position="right" label-width="80px" :model="mainObjInsert" :rules="rules" ref="mainObjInsert">
                <el-col :lg="5" :xl="5">
                    <el-form-item label="通道" prop="whCode" class="EL-Form-Item">
                        <el-select v-model="mainObjInsert.whCode" placeholder="请选择" filterable>
                            <el-option v-for="item in warehouseList" :key="item.whId" :value="item.whCode" :label="item.whCode+'-'+item.whName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="物料编号" prop="matCode" class="EL-Form-Item">
                        <!-- <el-input v-model="mainObj.matCode" placeholder="请输入" clearable></el-input> -->
                        <!-- <el-select v-model.trim="mainObj.matCode" placeholder="请选择" clearable filterable>
                            <el-option v-for="item in this.materialList" :key="item.mtId" :value="item.mtCode" :label="item.mtCode"></el-option>
                        </el-select> -->
                        <el-select v-model="mainObjInsert.matCode" filterable clearable remote :remote-method="remoteMethod" :loading="loading" @change="remoteMethod">
                            <el-option v-for="item in this.materialList" :key="item.mtId" :label="item.mtCode" :value="item.mtCode"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="批次" prop="batchNo" class="EL-Form-Item">
                        <el-input v-model="mainObjInsert.batchNo" placeholder="请输入" clearable></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="业务类型" prop="sorTypeSub" class="EL-Form-Item">
                        <el-select v-model.trim="mainObjInsert.sorTypeSub" clearable="clearable" placeholder="请选择" @change="getTransaction">
                            <!--<el-option key="10" value="10" label="RI"></el-option>
                            <el-option key="20" value="20" label="RP"></el-option>-->
                            <el-option key="30" value="IA" label="IA"></el-option>
                            <el-option key="40" value="IS" label="IS"></el-option>
                            <el-option key="50" value="SS" label="SS"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :lg="4" :xl="4">
                    <el-form-item class="btn-edit-delete EL-Form-Item">
                        <el-button class="btn-t-edit" @click="dataListAdd()">添加</el-button>
                    </el-form-item>
                </el-col>
                <el-col :lg="5" :xl="5">
                    <el-form-item label="成本中心" prop="reasonCode" class="EL-Form-Item">
                        <el-select v-model="mainObjInsert.reasonCode" clearable="clearable" filterable placeholder="请选择" >
                            <el-option :value="item.reasonCode" :label="item.reasonCode +'-'+ item.reasonDescription" :key="index" v-for="(item, index) in transationReasonData"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

              <el-col :lg="5" :xl="5">
                <el-form-item label="仓库类型" prop="saleFlag" class="EL-Form-Item">
                  <el-select v-model="mainObjInsert.saleFlag" placeholder="请选择" clearable="clearable">
                    <el-option value="false" label="非寄售仓"></el-option>
                    <el-option value="true" label="寄售仓"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="规值" prop="matSpecs" class="EL-Form-Item">
                  <el-input v-model="mainObjInsert.matSpecs" placeholder="请输入" clearable></el-input>
                </el-form-item>
              </el-col>
              <el-col :lg="5" :xl="5">
                <el-form-item label="外协单号" prop="soCode" class="EL-Form-Item">
                  <el-input v-model="mainObjInsert.soCode" placeholder="请输入" clearable></el-input>
                </el-form-item>
              </el-col>
            </el-form>
            <h-table :style="$popups.harvestRecordStyle(0.63)" :data="dataList">
                <el-table-column label="物料编号" align="center" prop="matCode">
                </el-table-column>
                <el-table-column label="物料描述" align="center" prop="matName">
                </el-table-column>
                <el-table-column label="调整数量" align="center" prop="matQuan" width="130px">
                    <template slot-scope="scope">
                        <el-input-number v-model="scope.row.matQuan" style="width: 100%;line-height: 26px !important" size="mini"></el-input-number>
                    </template>
                </el-table-column>
                <el-table-column label="批次号" align="center" prop="batchNo" width="130px">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.batchNo" placeholder="请输入" size="mini"></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="仓库类型" align="center" prop="saleFlag">
                  <template slot-scope="scope">

                      <el-select v-model="scope.row.saleFlag" placeholder="请选择" :clearable="true" >
                      <el-option value="false" label="非寄售仓"></el-option>
                      <el-option value="true" label="寄售仓"></el-option>
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="库位" align="center" prop="laCode">
                    <template slot-scope="scope">
                        <!-- <el-select v-model="scope.row.laCode" placeholder="请选择" size="mini" filterable allow-create default-first-option>
                            <el-option v-for="item in locationList" :key="item.lcId" :value="item.lcCode" :label="item.lcCode"></el-option>
                        </el-select> -->

                        <el-select v-model="scope.row.laCode" placeholder="请选择" :clearable="true" filterable remote :remote-method="remoteMethodLcCodeInsert">
                            <el-option v-for="(item) in locationList" :key="item.lcId" :label="item.lcCode" :value="item.lcCode">
                            </el-option>
                        </el-select>

                    </template>
                </el-table-column>
                <!-- <el-table-column label="包装箱号" align="center" prop="boxBarcode" width="130px">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.boxBarcode" placeholder="请输入" size="mini"></el-input>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="规值" align="center" prop="matSpecs">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.matSpecs" placeholder="请输入" size="mini"></el-input>
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="L值" align="center" prop="matLenValue">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.matLenValue" placeholder="请输入" size="mini"></el-input>
                    </template>
                </el-table-column> -->
                <el-table-column label="规值" align="center" prop="batchNo" width="130px">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.matSpecs" placeholder="请输入" size="mini"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="入库时间" align="center" prop="matCreateTime" width="230px">
                    <template slot-scope="scope">
                        <!-- <el-input v-model="scope.row.matCreateTime" placeholder="请输入" size="mini"></el-input> -->
                        <el-date-picker v-model="scope.row.matCreateTime" value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="保质期" align="center" prop="matValidTime">
                </el-table-column>
                <el-table-column label="库区" align="center" prop="whArea" width="150px">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.whArea" placeholder="请选择" size="mini" @change="scope.row.laCode = '', getLocationData(scope.row.whArea)" clearable>
                            <el-option v-for="item in dictDataList" :key="item.ddId" :value="item.ddCode" :label="item.ddCode+'-'+item.ddName"></el-option>
                        </el-select>
                    </template>
                </el-table-column> -->
                <el-table-column label="操作" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="dataListDel(scope.row)" class="btn-t-delete">删除</el-button>
                    </template>
                </el-table-column>
            </h-table>
            <div slot="footer" class="dialog-footer footer-bottom">
                <el-button size="mini" @click="close()" type="info">取 消</el-button>
                <el-button size="mini" :loading="saveOtherIns" class="btn-t-edit" @click="saveOtherIs()">确 认</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import moment from "moment";
    export default {
        name: "OtherRecordOut",
        data() {
            return {
                rules: {
                    fcCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "change",
                    }, ],
                    whCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "change",
                    }, ],
                    sorTypeSub: [{
                        required: true,
                        message: '请选择',
                        trigger: 'change'
                    }],
                    matCode: [{
                        required: true,
                        message: "请选择",
                        trigger: "change",
                    }, ],
                    saleFlag: [{
                      required: true,
                      message: "请选择",
                      trigger: "change",
                    }, ],
                    batchNo: [{
                        required: true,
                        message: "请输入",
                        trigger: "change",
                    }, ]
                },
                /* 首页显示的数据 */
                mainSearch: {
                    query: {
                        fcCode: localStorage.getItem("fcCode") || "",
                        lcCode: "",
                        whCode: "",
                        matCode: "",
                        matName: "",
                        batchNo: "",
                        boxBarcode: "",
                        date: [],
                    },
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    data: [],
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                /* 交易调整记录 */
                mainSearcRecord: {
                    query: {
                        fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                        //whCode: localStorage.getItem("whCode") || "", // 通道编号
                        sorType: "20",
                        sorTypeSub: "", //业务类型
                        reasonCode: "",//调整原因
                        matCode: "", //	物料编号
                        batchNo: "", //	批次号
                        boxBarcode: "", //	箱号
                        matSpecs: "", //	规值
                        matLenValue: "", //	L值
                        person: "", //	操作人
                        date: [],
                    },
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    data: [],
                    insertShowRecord: false,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec";
                    },
                },
                /* 交易调整 */
                mainObj: {
                    query: {
                        fcCode: localStorage.getItem("fcCode") || "",
                        sorTypeSub: "", //业务类型
                        matCode: "",
                        lcCode: "",
                        boxBarcode: "",
                        reasonCode:"",
                        person: localStorage.getItem("user"),
                        personcost:"",
                        personNumber: localStorage.getItem("empNumber"),
                    },
                    pageNum: 1,
                    pageSize: 50,
                    total: 0,
                    data: [],
                    insertShowRecord: false,
                    headerCellStyle: () => {
                        return "background-color: #1f6cec; color: #ffffff";
                    },
                },
                /* 交易新增调整调整 */
                mainObjInsert: {
                    fcCode: localStorage.getItem("fcCode") || "",
                    whCode: localStorage.getItem("whCode") || "",
                    sorTypeSub: "", //业务类型
                    matCode: "",
                    lcCode: "",
                    boxBarcode: "",
                    batchNo:"",
                    reasonCode:"",
                    matSpecs:"",
                    person: localStorage.getItem("user"),
                    personNumber: localStorage.getItem("empNumber"),
                    saleFlag:"",
                    soCode:"",
                    headerCellStyle: () => {
                        return "background-color: #1f6cec; color: #ffffff";
                    },
                },
                // 库区集合
                WhCodeList: [],
                // 库位集合
                lcCodeList: [],
                // 选择的交易数据
                putInMotionData: [],
                //选择的交易调整记录数据
                putInMotionDatas:[],
                // 物料列表
                materialList: [],
                // 新增交易调整数据
                checkList: [],
                // 下载中
                downloadLoading: false,
                // 完成后保存日志的内容
                logRemarks: "",
                // 输入框延时加载
                isSetTimeout: null,
                // 限制打印时间
                lazyNext: false,
                //IS交易类型都可以， 其他交易类型只有仓库管理员有权限
                roleCode: localStorage.getItem("roleCode"),

                //交易原因
                transationReasonData: [],

                personCost: [],
                //新增交易窗口
                insertShowNew: false,
                //存放库位集合
                locationList: [],
                //所有通道信息
                warehouseList:[],
                loading: false,
                dataList: [],
                saveOtherIns: false,
                writeXaList:[],
                //交易类型集合
                printList:[],
            };
        },
        watch: {
            "mainSearch.query": {
                handler() {
                    clearTimeout(this.isSetTimeout);
                    this.isSetTimeout = setTimeout(() => {
                        this.getTableData();
                    }, 1000);
                },
                deep: true,
            },
            "mainSearcRecord.query": {
                handler() {
                    clearTimeout(this.isSetTimeout);
                    this.isSetTimeout = setTimeout(() => {
                        this.getOtherRecordList();
                    }, 1000);
                },
                deep: true,
            },
            // "mainObj.query": {
            //     handler() {
            //         clearTimeout(this.isSetTimeout);
            //         this.isSetTimeout = setTimeout(() => {
            //             if (!this.putInMotionData.length) {
            //                 this.getWhData();
            //             }
            //         }, 1000);
            //     },
            //     deep: true,
            // },
        },
        computed: {
            startPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.query.date[1]) {
                            return time.getTime() > new Date(_this.mainSearch.query.date[1]);
                        }
                    },
                };
            },
            finishPickerOptions() {
                let _this = this;
                return {
                    disabledDate(time) {
                        if (_this.mainSearch.query.date[0]) {
                            return time.getTime() < new Date(_this.mainSearch.query.date[0]);
                        }
                    },
                };
            },

        },
        methods: {
            sorTypeSub(type) {
                if (type == "10") {
                    return "IA"
                } else if (type == "20") {
                    return "IS"
                } else if (type == "30") {
                    return "SS"
                } else if (type == "40") {
                    return "VR"
                }
            },

            sorTypeSubInsert(type) {
                if (type == "10") {
                    return "RI"
                } else if (type == "20") {
                    return "RP"
                } else if (type == "30") {
                    return "IA"
                } else if (type == "40") {
                    return "IS"
                } else if (type == "50") {
                    return "SS"
                }
            },

            insertOpenNew() {
                //this.getLocationData();
                if(this.putInMotionData.length != 0){
                    this.mainObjInsert.whCode = this.putInMotionData[0].whCode
                    this.mainObjInsert.matCode = this.putInMotionData[0].matCode
                    this.mainObjInsert.batchNo = this.putInMotionData[0].batchNo
                }
                if(localStorage.getItem("fcCode") == "DLM"){
                    this.mainObjInsert.whCode = "802"
                }else{
                    this.mainObjInsert.whCode = "800"
                }
                this.insertShowNew = true;
            },

            //表单验证
            submitForm(formName) {
                let r = Boolean;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        r = true;
                    } else {
                        r = false;
                    }
                });
                return r;
            },

            dataListDel(row) {
                var index = this.dataList.findIndex(item => {
                    if (item.index == row.index) {
                        return true;
                    }
                })
                this.dataList.splice(index, 1)
            },

            //判断走那个交易
            saveOtherIs(){
                if(this.mainObjInsert.sorTypeSub == '10' || this.mainObjInsert.sorTypeSub == '20'){
                    this.saveOtherIn();
                }else{
                    if (this.dataList.length == 0) {
                        this.$message({
                            message: "没有物料记录",
                            type: "warning",
                        })
                        return;
                    }
                    if (this.transationReasonData.length != 0 && this.mainObjInsert.reasonCode == "") {
                        this.$message({
                            message: "该交易必须选择成本中心！",
                            type: "warning",
                        })
                        return;
                    }
                    for (var index in this.dataList) {
                        if (this.dataList[index].laCode == '') {
                            this.$message({
                                message: "库位不允许为空",
                                type: "warning",
                            });
                            return;
                        }
                        if (this.dataList[index].matQuan == 0) {
                            this.$message({
                                message: "调整数量不能为0！",
                                type: "warning",
                            });
                            return;
                        }
                        if (this.dataList[index].matCreateTime == "" || this.dataList[index].matCreateTime == undefined) {
                            this.$message({
                                message: "请选择入库时间！",
                                type: "warning",
                            });
                            return;
                        }
                        if (this.dataList[index].saleFlag == "" || this.dataList[index].saleFlag == undefined) {
                          this.$message({
                            message: "请选择仓库类型！",
                            type: "warning",
                          });
                          return;
                        }
                    };
                    this.saveOtherInsert();
                }
            },
          //获取数据


            //新增交易IS IA SS
            saveOtherInsert(){
                this.saveOtherIns = true;
                this.$confirm("是否确认新增交易?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.dataList.forEach((obj)=>{
                        var type = this.mainObjInsert.sorTypeSub;
                        if(type == 'IA' || type == 'RW' || type == 'RP' || type == 'RI'){
                            //大于0相加的
                            obj.matQuan = obj.beforeMatQuan + obj.matQuan;
                        }else if(type == 'IW' || type == 'IS' || type == 'SS' || type == 'VR'){
                            //大于0 需要扣的
                            obj.matQuan = obj.beforeMatQuan - obj.matQuan;
                        }
                    })
                    this.$http.request({
                        url: "/api/otherRecord/saveOtherInsert",
                        method: "POST",
                        showLoading: true,
                        params:{
                            opearType: this.mainObjInsert.sorTypeSub,
                            reasonCode: this.mainObjInsert.reasonCode,
                            person: localStorage.getItem("user"),
                            personNumber:localStorage.getItem("empNumber"),
                            soCode:this.mainObjInsert.soCode,
                        },
                        data: this.dataList,
                    }).then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.dataList = [];
                            this.insertShow = false;
                            this.getTableData();
                            this.logRemarks = "otherRecord：新增记录成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "otherRecord：新增记录失败";
                        }
                        this.saveOtherIns = false;

                        //打印标签
                        this.printList = resp.data.list || [];
                        this.printList.forEach((item) => {
                            var produceTime = moment(item.matCreateTime).format("YYYYMMDD");
                            //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                            var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                                item.matCode + "," + item.matQuan + "," + item.matSpecs +
                                "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                            if (!item.matSpecs)item.matSpecs = "";

                            var person = localStorage.getItem("user");
                            if (person != undefined && person != '') {
                                person = item.consignee || "";
                            }

                            var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                            var barcodeData = {
                                boxBarcode: item.boxBarcode,
                                prodCode: item.matCode,
                                prodName: item.matName,
                                batchNo: item.batchNo,
                                count: item.matQuan,
                                checkPerson: person,
                                date: produceTime,
                                poCode: item.orderCode,
                                matSpecs: item.matSpecs,
                                whCode: item.whCode,
                                qrCode: qrCode,
                                supply: "",
                                printTime: printTime,
                                isSta: false,
                                printTwo: false,
                                location: item.lcCode
                            }
                            // 调用打印收货标签
                            this.$printer.printWMSBarcode(barcodeData);
                        })

                        this.logContent = JSON.stringify(this.mainObj);
                        this.systemLog();
                    }).catch((error) => {
                        this.saveOtherIns = false;
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
                }).catch(() => {
                    this.saveOtherIns = false;
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
            },

            //新增杂入记录
            saveOtherIn() {
                if (this.dataList.length == 0) {
                    this.$message({
                        message: "没有物料记录",
                        type: "warning",
                    })
                    return;
                }
                for (var index in this.dataList) {
                    if (this.dataList[index].laCode == '') {
                        this.$message({
                            message: "库位不允许为空",
                            type: "warning",
                        });
                        return;
                    }
                };
                this.saveOtherIns = true;
                this.$confirm("是否确认新增杂入物料?", "提示", {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.$http.request({
                        url: "/api/otherRecord/saveOtherIn",
                        method: "POST",
                        showLoading: true,
                        data: this.dataList,
                    }).then((resp) => {
                        if (resp.status == 100) {
                            this.$notify({
                                title: "成功",
                                message: "新增成功！",
                                type: "success",
                            });
                            this.dataList = [];
                            this.insertShow = false;
                            this.getTableData();
                            this.logRemarks = "otherRecord：新增杂入记录成功";
                        } else {
                            this.$notify.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "otherRecord：新增杂入记录失败";
                        }
                        this.saveOtherIns = false;
                        this.logContent = JSON.stringify(this.mainObj);
                        this.systemLog();
                    }).catch((error) => {
                        this.saveOtherIns = false;
                        this.$notify.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
                }).catch(() => {
                    this.saveOtherIns = false;
                    this.$message({
                        type: "info",
                        message: "已取消",
                    });
                });
            },

            close() {
                this.insertShowNew = false
                this.mainObjInsert.sorTypeSub = ""
                this.mainObjInsert.matCode = ""
                this.mainObjInsert.whCode = "";
                this.mainObjInsert.batchNo = "";
                this.mainObjInsert.reasonCode = "";
                this.dataList = []
            },

            //添加
            dataListAdd() {
                if (this.submitForm("mainObjInsert")) {
                    let materialData = ''; //物料信息
                    this.$http.request({
                        url: "/api/material/info",
                        method: "GET",
                        params: {
                            prodCode: this.mainObjInsert.matCode,
                        },
                    }).then((resp) => {
                        if (resp.status == 100) {
                            materialData = resp.data;
                            if (!materialData) {
                                this.$message({
                                    message: "物料不存在",
                                    type: "warning",
                                })
                            }

                            //根据物料编号和批次查询和交易类型查询交易记录
                            this.$http.request({
                                url: "/api/writeXa/getWriteXaAll",
                                method: "GET",
                                params: {
                                    fcCode: this.mainObjInsert.fcCode || null,
                                    matCode: this.mainObjInsert.matCode || null,
                                    batchNo: this.mainObjInsert.batchNo || null,
                                    tranType: this.sorTypeSubInsert(this.mainObjInsert.sorTypeSub) || null,
                                    pageNum: 1,
                                    pageSize: 20,
                                },
                            }).then((resp) => {
                                if (resp.status == 100) {
                                    this.writeXaList = resp.data.list || [];
                                    let tabData = {
                                index: this.dataList.length,
                                fcCode: this.mainObjInsert.fcCode || null,
                                whCode: this.mainObjInsert.whCode || null,
                                sorType: '10',
                                sorTypeSub: this.mainObjInsert.sorTypeSub || null,
                                matCode: materialData.mtCode || null,
                                matName: materialData.mtName || null,
                                // matDesc: materialData.mtDesc || null,
                                matQuan: 0,
                                batchNo: this.mainObjInsert.batchNo || null,
                                boxBarcode: '',
                                matSpecs: this.mainObjInsert.matSpecs || null,
                                matLenValue: materialData.mtSpecsValue || null,
                                matCreateTime: this.writeXaList.length !=0 ? this.writeXaList[0].fifoDate:moment().format("YYYY-MM-DD"),
                                matValidTime: materialData.validityMonth || null,
                                whArea: '',
                                laCode: '',
                                beforeMatQuan:0,
                                saleFlag:this.mainObjInsert.saleFlag,
                                person: localStorage.getItem('user'),
                                personNumber: localStorage.getItem("empNumber"),
                            }
                            this.dataList.push(tabData)
                                }
                            }).catch((error) => {});

                        } else {
                            this.$message({
                                message: "物料不存在",
                                type: "warning",
                            })
                        }
                    }).catch((error) => {});
                }
            },

            /**
             * 获取库位
             */
            getLocationData(ddCode) {
                this.$http.request({
                    url: "/api/location/getLaCodeAllByType",
                    method: "GET",
                    params: {
                        fcCode: this.mainObj.query.fcCode || null,
                        // whCode: this.mainObj.whCode || null,
                        lcType: 'QC,FLOOR'
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.locationList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },
            //通道列表
            getWarehouse() {
                this.$http.request({
                    url: "/api/warehouse/getWarehouse",
                    method: "GET",
                    params: {
                        fcCode: this.mainObj.query.fcCode || null,
                    },
                }).then((resp) => {
                    if (resp.status == 100) {
                        this.warehouseList = resp.data.list || [];
                    }
                }).catch((error) => {});
            },
            //主页标签打印
            printBarcode(){
                if (!this.putInMotionData.length) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.putInMotionData.forEach((item) => {
                        var produceTime = moment(item.matCreateTime).format("YYYYMMDD");
                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (!item.matSpecs)item.matSpecs = "";

                        var person = localStorage.getItem("user");
                        if (person != undefined && person != '') {
                            person = item.consignee || "";
                        }

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxBarcode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.batchNo,
                            count: item.matQuan,
                            checkPerson: person,
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: "",
                            printTime: printTime,
                            isSta: false,
                            printTwo: false,
                            location: item.lcCode
                        }
                        // 调用打印收货标签
                        this.$printer.printWMSBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = false;
                    }, 5000)
                }
            },

            /* 新增调整记录 */
            saveOtherOut() {
                if (!this.mainObj.query.sorTypeSub) {
                    this.$message({
                        type: "warning",
                        message: "请选择交易类型",
                    });
                    return;
                }
                if (this.checkList.length == 0) {
                    this.$message({
                        message: "请选择物料记录",
                        type: "warning",
                    });
                    return;
                }
                if(this.transationReasonData.length != 0 && this.mainObj.query.reasonCode == ""){
                    this.$message({
                        message: "IA交易必须选择交易成本中心！",
                        type: "warning",
                    });
                    return;
                }
                if (this.mainObj.query.sorTypeSub == 'IS' && this.mainObj.query.reasonCode == '') {
                    this.$message({
                        message: "IS交易必须选择交易成本中心！",
                        type: "warning",
                    });
                    return;
                }

                var lengthFlag = false;

                var matQuanFlag = false;

                var barcodes = "";

                this.mainObj.data.forEach((obj) => {
                    if(barcodes == ''){
                        barcodes = obj.boxBarcode;
                    }else{
                        barcodes += "," + obj.boxBarcode;
                    }
                });

                for(var index in this.checkList){
                    //VR退货时数量不能小于0
                    if(this.mainObj.query.sorTypeSub == 'VR'){

                        if(this.checkList[index].adjustMatQuan < 0){

                           this.$message({
                                message: this.mainObj.query.sorTypeSub + " 调整数量不能小于0",
                                type: "warning",
                            });
                            return;

                        }

                    }

                    //报废需要填写原因
                    if(this.mainObj.query.sorTypeSub == 'SS' && (this.mainObj.query.reasonCode == undefined || this.mainObj.query.reasonCode == '')){
                        this.$message({
                            message: this.mainObj.query.sorTypeSub + "需要选择成本中心",
                            type: "warning",
                        });
                        return;

                    }

                    if((this.checkList[index].matCode != this.checkList[index].newMatCode) && (this.checkList[index].batchNo != this.checkList[index].newBatchNo)){

                        this.$message({
                            message: "IA交易调整不能同时调整物料编号和规值！",
                            type: "warning",
                        });
                        return;

                    }

                }

                this.checkList.forEach((obj) => {

                    if(obj.sorTypeSub == "IA"){
                        //去掉IA物料编号和批次的空格
                        obj.newMatCode = obj.newMatCode.trim();
                        obj.newBatchNo = obj.newBatchNo.trim();
                    }

                    //计算调整后的数量
                    var type = this.mainObj.query.sorTypeSub;
                    if(type == 'IA' || type == 'RW' || type == 'RP' || type == 'RI'){
                        //大于0相加的
                        obj.matQuan = obj.beforeMatQuan + obj.adjustMatQuan;
                    }else if(type == 'IW' || type == 'IS' || type == 'SS' || type == 'VR'){
                        //大于0 需要扣的
                        obj.matQuan = obj.beforeMatQuan - obj.adjustMatQuan;
                    }


                    //添加操作人，操作工号
                    obj.person = localStorage.getItem('user');
                    obj.personNumber = localStorage.getItem("empNumber");

                    if (obj.newBatchNo != undefined && obj.newBatchNo.length > 10) {
                        lengthFlag = true;
                    }

                    if(isNaN(obj.adjustMatQuan) || obj.adjustMatQuan == 0){
                        matQuanFlag = true;
                    }

                    // 添加交易类型
                    obj.sorTypeSub = this.mainObj.query.sorTypeSub;
                    // 如果为IA时判断当前新批次是否存在

                    if (
                        obj.sorTypeSub == "IA" &&
                        obj.newBatchNo != undefined &&
                        obj.newBatchNo != "" && obj.batchNo != obj.newBatchNo
                    ) {
                        // 根据批次截取规值
                        // var dataMap = obj.newBatchNo.split("/");
                        // if (dataMap.length == 2) {
                        //     if (dataMap[0].indexOf("+") > -1 || dataMap[0].indexOf("-") > -1) {
                        //         obj.matSpecs = dataMap[0];
                        //     } else if (
                        //         dataMap[1].indexOf("+") > -1 ||
                        //         dataMap[1].indexOf("-") > -1
                        //     ) {
                        //         obj.matSpecs = dataMap[1];
                        //     }
                        // }
                        obj.batchNo = obj.newBatchNo;
                    }
                });

                if (lengthFlag) {
                    this.$message({
                        message: "新批次号长度不能超过10位",
                        type: "warning",
                    });
                    return;
                }

                if (matQuanFlag) {
                    this.$message({
                        message: "请填写调整数量",
                        type: "warning",
                    });
                    return;
                }
                console.log(this.checkList);
                this.$http
                    .request({
                        url: "/api/otherRecord/saveOtherOut",
                        method: "POST",
                        showLoading: true,
                        data: this.checkList,
                        params: {
                            opearType: this.mainObj.query.sorTypeSub,
                            reasonCode: this.mainObj.query.reasonCode,
                            personCost: this.mainObj.query.personcost,
                            barcodes: barcodes
                        }
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.$message({
                                title: "成功",
                                message: "调整成功！",
                                type: "success",
                            });
                            // this.getTableData();
                            this.mainObj.query.sorTypeSub = "";
                            this.mainObj.query.reasonCode = "";
                            // this.closeDialogClick('mainObj');
                            if(resp.data.total != 0){
                                resp.data.list.forEach(ele => {
                                    ele.beforeMatQuan = ele.matQuan;
                                    ele.newBatchNo = ele.batchNo;
                                    ele.newMatCode = ele.matCode;
                                    ele.adjustMatQuan = 1;
                                });
                                this.mainObj.data = JSON.parse(JSON.stringify(resp.data.list));
                            }else{
                                this.mainObj.data = [];
                            }

                            this.logRemarks = "otherRecord：新增杂出记录成功";
                        } else {
                            this.$message.error({
                                title: "失败",
                                message: resp.message,
                            });
                            this.logRemarks = "otherRecord：新增杂出记录失败";
                        }
                        this.saveOtherOuts = false;

                        this.systemLog();
                    })
                    .catch((error) => {
                        this.saveOtherOuts = false;
                        this.$message.error({
                            title: "失败",
                            message: "调用失败",
                        });
                    });
            },
          getSummaries(param) {
            const { columns, data } = param;
            const sums = [];
            columns.forEach((column, index) => {
              if (index === 0) {
                sums[index] = '合计';
                return;
              }
              const values = data.map(item => Number(item[column.property]));
              if (!values.every(value => isNaN(value)) && (column.property == "matQuan")) {
                sums[index] = values.reduce((prev, curr) => {
                  const value = Number(curr);
                  if (!isNaN(value)) {
                    return prev + curr;
                  } else {
                    return prev;
                  }
                }, 0);
                sums[index];
              }
            });

            return sums;
          },
            /* 获取交易调整的数据 */
            getWhData() {
                clearTimeout(this.isSetTimeout);
                this.$http
                    .request({
                        url: "/api/inventory/getWhData",
                        method: "GET",
                        params: {
                            pageSize: this.mainObj.pageSize,
                            pageNum: this.mainObj.pageNum,
                            fcCode: this.mainObj.query.fcCode || null, //	工厂编号
                            matCode: this.mainObj.query.matCode || null, //	物料编号
                            boxBarcode: this.mainObj.query.boxBarcode || null, //	箱号
                            lcCode: this.mainObj.query.lcCode || null, //	货位
                            wiStatus: "NORMAL",
                            sorTypeSub: this.mainObj.query.sorTypeSub,
                            allFlag: true
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            var arr = resp.data.list || [];
                            this.mainObj.total = resp.data.total || 0;
                            if (arr.length == 0) {
                                this.$message({
                                    message: "库存不存在",
                                    type: "warning",
                                });
                                this.mainObj.data = []
                            }
                            this.mainObj.data = []
                            arr.forEach((ele) => {
                                var obj = {
                                    index: arr.length,
                                    fcCode: ele.fcCode || null,
                                    whCode: ele.whCode || null,
                                    sorType: '20',
                                    matCode: ele.matCode || null,
                                    matName: ele.matName || null,
                                    matDesc: ele.matName || null,
                                    beforeMatQuan: ele.matQuan || null,
                                    matQuan: ele.matQuan || null,
                                    batchNo: ele.batchNo || null,
                                    boxBarcode: ele.boxBarcode || null,
                                    matSpecs: ele.matSpecs || null,
                                    matLenValue: ele.matLenValue || null,
                                    matCreateTime: ele.matCreateTime.substring(0, 10),
                                    whArea: ele.lcType || null,
                                    laCode: ele.lcCode || null,
                                    person: localStorage.getItem('user'),
                                    personNumber: localStorage.getItem("empNumber"),
                                    newBatchNo: ''
                                }
                                this.mainObj.data.push(obj);
                            })
                        } else {
                            this.$message({
                                message: "物料不存在",
                                type: "warning",
                            });
                        }
                    })
                    .catch((error) => {});
                // }
            },
            /* 交易选择 */
            selectRepertory(selection) {
                this.putInMotionData = selection;
            },
            /* 交易调整记录表格 */
            selectAdjustment(selection) {
                this.putInMotionDatas = selection;
            },
            /* 选择交易进行调整 */
            selectAll(val) {
                this.checkList = val;
            },
            /* 交易调整记录弹出框 */
            insertOpenRecord() {
                this.mainSearcRecord.insertShowRecord = true;
                this.mainObj.query.sorTypeSub = "";
                this.getOtherRecordList();
            },
            /* 交易调整弹出框 */
            insertOpen() {
                if (this.putInMotionData.length == 0) {
                    this.$message({
                        message: "选择需要调整的记录",
                        type: "warning",
                    });
                    return false;
                } else {
                  var isFlag = false;
                  this.putInMotionData.forEach((item)=>{
                    item['traferCode'] = "";
                    if(item.matDistrQuan>0){
                      this.$message({
                        type: "info",
                        message: "已经分配的库存不能移库！",
                      });
                      isFlag = true;
                      return;
                    }
                  })
                  if(isFlag){
                    return;
                  }
                    this.mainObj.insertShowRecord = true;
                    this.putInMotionData.forEach(ele => {
                        ele.beforeMatQuan = ele.matQuan;
                        ele.newBatchNo = ele.batchNo;
                        ele.newMatCode = ele.matCode;
                        ele.adjustMatQuan = ele.matQuan;
                    });
                    this.mainObj.data = JSON.parse(JSON.stringify(this.putInMotionData));
                }
            },
            rpReceipt(){
                if (this.putInMotionData.length == 0) {
                  this.$message({
                    message: "选择需要调整的记录",
                    type: "warning",
                  });
                  return false;
                }
              if (this.putInMotionData.length > 1) {
                this.$message({
                  message: "只能选择一条要调整的记录",
                  type: "warning",
                });
                return false;
              }

              this.$http.request({
                url: "/api/otherRecord/rpReceipt",
                method: "POST",
                showLoading: true,
                params:{
                  opearType: "RP",
                  boxBarcode: this.putInMotionData[0].boxBarcode,
                  person: localStorage.getItem("user"),
                  personNumber:localStorage.getItem("empNumber"),
                },
                data: this.dataList,
              }).then((resp) => {
                if (resp.status == 100) {
                  this.$notify({
                    title: "成功",
                    message: "收货成功！",
                    type: "success",
                  });

                  this.getTableData();

                } else {
                  this.$notify.error({
                    title: "失败",
                    message: resp.message,
                  });

                }

              }).catch((error) => {
                  this.$notify.error({
                    title: "失败",
                    message: "调用失败",
                  });
                });



            },
            /* 查询交易调整记录数据 */
            getOtherRecordList() {
                this.$http
                    .request({
                        url: "/api/otherRecord/otherView/getOtherRecordList",
                        method: "GET",
                        params: {
                            pageNum: this.mainSearcRecord.pageNum, // 页号
                            pageSize: this.mainSearcRecord.pageSize, // 页大小
                            fcCode: this.mainSearcRecord.query.fcCode || null, // 工厂编号
                            whCode: this.mainSearcRecord.query.whCode || null, // 通道编号
                            sorType: this.mainSearcRecord.query.sorType || null,
                            sorTypeSub: this.mainSearcRecord.query.sorTypeSub || null, //业务类型
                            matCode: this.mainSearcRecord.query.matCode || null, //物料编号
                            batchNo: this.mainSearcRecord.query.batchNo || null, //批次号
                            boxBarcode: this.mainSearcRecord.query.boxBarcode || null, //箱号
                            matSpecs: this.mainSearcRecord.query.matSpecs || null, //规值
                            matLenValue: this.mainSearcRecord.query.matLenValue || null, //L值
                            person: this.mainSearcRecord.query.person || null, //操作人
                            beginTime: this.mainSearcRecord.query.date ?
                                this.mainSearcRecord.query.date[0] : null,
                            endTime: this.mainSearcRecord.query.date ?
                                this.mainSearcRecord.query.date[1] : null,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainSearcRecord.data = res.data.list;
                            this.mainSearcRecord.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    })
                    .catch((error) => {
                        this.$message.error("错误");
                    });
            },
            /* 所有弹出框关闭的点击事件 */
            closeDialogClick(type) {
                if (type == "mainSearcRecord") {
                    this.mainSearcRecord.insertShowRecord = false;
                } else if (type == "mainObj") {
                    this.mainObj.insertShowRecord = false;
                    this.getTableData();
                    // this.mainObj.query = {
                    //     fcCode: localStorage.getItem("fcCode") || "",
                    //     sorTypeSub: "", //业务类型
                    //     matCode: "",
                    //     lcCode: "",
                    //     boxBarcode: "",
                    //     person: localStorage.getItem("user"),
                    //     personNumber: localStorage.getItem("empNumber"),
                    // };
                }
            },
            /* 所有查询的点击事件 */
            inquireDataClick(type) {
                if (type == "mainSearch") {
                    this.mainSearch.pageNum = 1;
                    this.getTableData();
                }
            },
            /* 所有重置的点击事件 */
            resetClick(type) {
                if (type == "mainSearch") {
                    this.mainSearch.query = {
                        fcCode: localStorage.getItem("fcCode") || "",
                        lcCode: "",
                        whCode: "",
                        matCode: "",
                        matName: "",
                        batchNo: "",
                        boxBarcode: "",
                        date: [],
                    };
                } else if (type == "mainSearcRecord") {
                    this.mainSearcRecord.query = {
                        fcCode: localStorage.getItem("fcCode") || "", // 工厂编号
                        //whCode: localStorage.getItem("whCode") || "", // 通道编号
                        sorType: "20",
                        sorTypeSub: "", //业务类型
                        matCode: "", //	物料编号
                        batchNo: "", //	批次号
                        boxBarcode: "", //	箱号
                        matSpecs: "", //	规值
                        matLenValue: "", //	L值
                        person: "", //	操作人
                        date: [],
                    };
                }
            },
          getAuxiMaterialData() {
            var paramsObj2 = {
              pageNum: 1,
              pageSize: 999999,
            };
            this.$http
                .request({
                  url: "/api/personCost/getPsersonCost",
                  method: "GET",
                  params: paramsObj2,
                })
                .then((resp) => {
                  // this.loading--
                  if (resp.status == 100) {
                    // console.log(resp.data.list.length);
                    this.personCost = resp.data.list || [];

                  }
                })
                .catch((error) => {
                  // this.loading--;
                });
          },
            /* 获取所有的通道(根据用户工厂) */
            getSysWarehouseAll() {
                this.$http
                    .request({
                        url: "/api/sysWarehouse/getSysWarehouseAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.WhCodeList = resp.data;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /* 获取所有的库位 */
            getSysLocationAll(lcCode) {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcCode: lcCode || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.lcCodeList = resp.data.list;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
          getCost(value){
              //成本中心值
            this.mainObj.query.reasonCode = "";
            //成本中心list
            //this.transationReasonData = [];
            var cost = "";
            this.personCost.forEach(function(c) {
              if(c.person == value){
                cost = c.cost;
              }
            })
            this.transationReasonData.forEach((c)=> {

              if(c.reasonCode == cost){
                console.log(c.reasonCode);
                //this.$set(this.mainObj.query,"reasonCode",cost)

                this.mainObj.query.reasonCode = cost;

                console.log(this.mainObj.query.reasonCode + "this.mainObj.query.reasonCode");
              }
            })
          },
            /* 获取所有的库位 */
            getSysLocationAllInsert(lcCode) {
                this.$http
                    .request({
                        url: "/api/location/getLaCodeAllByType",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            lcCode: lcCode || "",
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.locationList = resp.data.list;
                        }
                    })
                    .catch((error) => {
                        this.$message({
                            message: "操作失败",
                            type: "warning",
                        });
                    });
            },
            /* 远程搜索库位号 */
            remoteMethodLcCode(query) {
                if (query || query == 0) {
                    // this.lcCodeLoading = true;
                    this.getSysLocationAll(query);
                    setTimeout(() => {
                        // this.lcCodeLoading = false;
                        if (this.lcCodeList != undefined) {
                            this.lcCodeList = this.lcCodeList.filter((item) => {
                                return (
                                    item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1
                                );
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeList = [];
                }
            },
            /* 远程搜索库位号 */
            remoteMethodLcCodeInsert(query) {
                if (query || query == 0) {
                    // this.lcCodeLoading = true;
                    this.getSysLocationAllInsert(query);
                    setTimeout(() => {
                        // this.lcCodeLoading = false;
                        if (this.locationList != undefined) {
                            this.locationList = this.locationList.filter((item) => {
                                return (
                                    item.lcCode.toLowerCase().indexOf(query.toLowerCase()) > -1
                                );
                            });
                        }
                    }, 200);
                } else {
                    this.lcCodeList = [];
                }
            },
            /* 远程搜索物料编号 */
            remoteMethod(query) {
                this.loading = true;
                if (query !== "") {
                    this.mainObj.matCode = query;
                    this.getMaterial();
                } else {
                    this.mainObj.matCode = "";
                    this.getMaterial();
                }
                setTimeout(() => {
                    this.loading = false;
                    if (this.materialList != undefined) {
                        this.materialList = this.materialList.filter((item) => {
                            return item.mtCode.toLowerCase().indexOf(query.toLowerCase()) > -1;
                        });
                    }
                }, 200);
            },
            //物料列表
            getMaterial() {
                this.$http
                    .request({
                        url: "/api/material/getMaterialAll",
                        method: "GET",
                        params: {
                            fcCode: localStorage.getItem("fcCode") || "",
                            mtCode: this.mainObj.matCode || null,
                            pageNum: 1,
                            pageSize: 1000,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.materialList = res.data.list;
                        } else {
                            this.$message.error("错误");
                        }
                    });
            },
            /* 获取首页的数据 */
            getTableData() {
                this.$http
                    .request({
                        url: "/api/order/getStockListMatCreateTime",
                        method: "GET",
                        params: {
                            fcCode: this.mainSearch.query.fcCode || null,
                            whCode: this.mainSearch.query.whCode || null,
                            matCode: this.mainSearch.query.matCode || null,
                            matName: this.mainSearch.query.matName || null,
                            batchNo: this.mainSearch.query.batchNo || null,
                            boxBarcode: this.mainSearch.query.boxBarcode || null,
                            lcCode: this.mainSearch.query.lcCode || null,
                            beginTime: this.mainSearch.query.date ?
                                this.mainSearch.query.date[0] : null,
                            endTime: this.mainSearch.query.date ?
                                this.mainSearch.query.date[1] : null,
                            pageNum: this.mainSearch.pageNum,
                            pageSize: this.mainSearch.pageSize,
                        },
                    })
                    .then((res) => {
                        if (res.status == 100) {
                            this.mainSearch.data = res.data.list || [];
                            this.mainSearch.total = res.data.total;
                        } else {
                            this.$message.error("错误");
                        }
                    })
                    .catch((error) => {
                        this.$message.error("错误");
                    });
            },
            // 交易调整记录表格导出
            downLoadFiles(){
                this.downloadLoading = true;
                this.$http
                    .request({
                        url: "/api/otherRecord/otherView/getOtherRecordList",
                        method: "GET",
                        params: {
                            pageNum: 1,
                   			pageSize: 999999,
                            fcCode: this.mainSearcRecord.query.fcCode || null, // 工厂编号
                            whCode: this.mainSearcRecord.query.whCode || null, // 通道编号
                            sorType: this.mainSearcRecord.query.sorType || null,
                            sorTypeSub: this.mainSearcRecord.query.sorTypeSub || null, //业务类型
                            matCode: this.mainSearcRecord.query.matCode || null, //物料编号
                            batchNo: this.mainSearcRecord.query.batchNo || null, //批次号
                            boxBarcode: this.mainSearcRecord.query.boxBarcode || null, //箱号
                            matSpecs: this.mainSearcRecord.query.matSpecs || null, //规值
                            matLenValue: this.mainSearcRecord.query.matLenValue || null, //L值
                            person: this.mainSearcRecord.query.person || null, //操作人
                            beginTime: this.mainSearcRecord.query.date ?
                                this.mainSearcRecord.query.date[0] : null,
                            endTime: this.mainSearcRecord.query.date ?
                                this.mainSearcRecord.query.date[1] : null,
                        },
                    })
                    .then((resp) => {
                       resp.status == 100 ? this.downLoads(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                    })
            },
            downLoads(list){
				list.forEach(function(c) {
					if(c.sorTypeSub == 'IA' || c.sorTypeSub == 'RW' || c.sorTypeSub == 'RP'){
                        c['matQuan'] = c.matQuan - c.beforeMatQuan;
                    } else if(c.sorTypeSub == 'IW' || c.sorTypeSub == 'SS' || c.sorTypeSub == 'IS' || c.sorTypeSub == 'VR'){
                        c['matQuan'] = c.beforeMatQuan - c.matQuan
                    }
				});

                import('@/libs/Export2Excel').then(excel => {
                    const tHeader = ['通道编号', '交易单号', '物料编号','物料描述', '物料数量', '调整数量', '物料批次', '库位', '包装编号','交易类型', '操作时间', '规值', '操作人',"申请人","成本中心"]
                    const filterVal = ['whCode', 'sorCode','matCode', 'matName', 'beforeMatQuan', 'matQuan', 'batchNo', 'laCode', 'boxBarcode', 'sorTypeSub', 'createTime', 'matSpecs', 'person','personCost','reasonCode']
                    const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '交易调整记录'
                    })
                    this.logRemarks = "otherRecord：导出交易调整记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            //表格导出
            downLoadFile() {
                this.downloadLoading = true;
                var paramsObj = {
                    fcCode: this.mainSearch.query.fcCode || null,
                    whCode: this.mainSearch.query.whCode || null,
                    matCode: this.mainSearch.query.matCode || null,
                    matName: this.mainSearch.query.matName || null,
                    batchNo: this.mainSearch.query.batchNo || null,
                    boxBarcode: this.mainSearch.query.boxBarcode || null,
                    lcCode: this.mainSearch.query.lcCode || null,
                    beginTime: this.mainSearch.query.date ? this.mainSearch.query.date[0] : null,
                    endTime: this.mainSearch.query.date ? this.mainSearch.query.date[1] : null,
                    pageNum: 1,
                    pageSize: 999999,
                }
                this.$http.request({
                    url: '/api/order/getStockList',
                    method: 'GET',
                    params: paramsObj
                }).then((resp) => {
                    resp.status == 100 ? this.downLoad(resp.data.list || []) : this.$notify.error({
                        message: '查询失败'
                    });
                })
            },
            downLoad(list) {
                import('@/libs/Export2Excel').then(excel => {
                      list.forEach(function(c) {
                        if (c.wiStatus == 'NORMAL') {
                            c['wiStatus'] = '正常'
                        } else if (c.wiStatus == 'FREEZE') {
                            c['wiStatus'] = '冻结'
                        } else if (c.wiStatus == 'OVERTIME') {
                            c['wiStatus'] = '过期'
                        } else if (c.wiStatus == 'DELETE') {
                            c['wiStatus'] = '作废'
                        } else if (c.wiStatus == 'AGFREEZE') {
                            c['wiStatus'] = '人工冻结'
                        }
                    })
                  const tHeader = ['通道编号', '物料编号', '物料描述', '物料总数量',   '物料批次', '库位', '包装箱号', '订单编号', '规值',
                    '热处理批号','钢材炉号','物料状态', '收货人', '入库时间','质检状态', '仓库类型','原箱号','供应商','供应商名称','备注'
                  ]
                  const filterVal = ['whCode', 'matCode', 'matName', 'matQuan',   'batchNo', 'lcCode', 'boxBarcode', 'orderCode', 'matSpecs',
                    'heatNumber','heatNo','wiStatus', 'consignee', 'matCreateTime', 'checkResult','saleFlag','oldBoxBarcode','verdorCode','svName','remark'
                  ]
                  const data = this.formatJson(filterVal, list)
                    excel.export_json_to_excel({
                        header: tHeader,
                        data,
                        filename: '交易调整'
                    })
                    this.logRemarks = "otherRecord：导出交易调整记录"
                    this.systemLog();
                    this.downloadLoading = false
                })
            },
            // 标签打印
            rePrintBarcode(){
                if (!this.checkList.length) {
                    this.$message({
                        message: "请勾选打印单！",
                        type: "warning",
                    });
                    return;
                }
                //无码时添加打印限制
                if (this.lazyNext) {
                    this.$message.error('请五秒后再打印！')
                    return
                } else {
                    this.checkList.forEach((item) => {
                        var produceTime = moment(item.matCreateTime).format("YYYYMMDD");
                        //箱号，采购订单，通道，物料号，数量，规值，批次，生产日期，高度，钢号，钢材炉号，锻造炉号
                        var qrCode = item.boxBarcode + "," + item.orderCode + "," + item.whCode + "," +
                            item.matCode + "," + item.matQuan + "," + item.matSpecs +
                            "," + item.batchNo + "," + produceTime + "," + item.boxHeight + ",,,";

                        if (!item.matSpecs)item.matSpecs = "";

                        var person = localStorage.getItem("user");
                        if (person != undefined && person != '') {
                            person = item.consignee || "";
                        }

                        var printTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        var barcodeData = {
                            boxBarcode: item.boxBarcode,
                            prodCode: item.matCode,
                            prodName: item.matName,
                            batchNo: item.batchNo,
                            count: item.matQuan,
                            checkPerson: person,
                            date: produceTime,
                            poCode: item.orderCode,
                            matSpecs: item.matSpecs,
                            whCode: item.whCode,
                            qrCode: qrCode,
                            supply: "",
                            printTime: printTime,
                            isSta: false,
                            printTwo: false,
                            location: item.lcCode
                        }
                        // 调用打印收货标签
                        this.$printer.printWMSBarcode(barcodeData);
                    })

                    this.lazyNext = setTimeout(() => {
                        this.lazyNext = false;
                    }, 5000)
                }
            },
            formatJson(filterVal, jsonData) {
                return jsonData.map(v => filterVal.map(j => v[j]))
            },
            /* 操作日志 */
            systemLog() {
                let objData = {
                    logType: "交易调整",
                    logContent: this.logRemarks || "",
                    //logRemarks: this.logRemarks || "",
                    logUser: localStorage.getItem("user") || "",
                };
                this.$http
                    .request({
                        url: "api/log/insert",
                        method: "POST",
                        showLoading: true,
                        data: objData,
                    })
                    .then((resp) => {
                        this.logRemarks = "";
                        if (resp.status == 100) {}
                    })
                    .catch((error) => {});
            },
            //获取数据
            getTransaction(type) {
                this.$http
                    .request({
                        url: "/api/transaction/getTransactionAll",
                        method: "GET",
                        params: {
                            transactionType: type,
                            pageNum: 1,
                            pageSize: 100,
                            reasonCode: ''
                        },
                    })
                    .then((resp) => {
                        if (resp.status == 100) {
                            this.transationReasonData = resp.data.list || [];
                            this.mainObjInsert.reasonCode = "";
                        }
                    })
                    .catch((error) => {

                    });
            },

            /**
             * 新增交易记录
             */
            insertTran(){
               this.mainObj.data = {
                   whCode: '',
                   matCode: '',

               }
            }
        },
        activated(){
            this.getAuxiMaterialData();
            /* 获取所有的通道 */
            this.getSysWarehouseAll();
            /* 获取所有的库位 */
            this.getSysLocationAll();
            /* 获取首页的数据 */
            this.getTableData();
            this.getWarehouse();

        },
    };
</script>
<style  lang="scss" scoped>
    .dao {
        float: right;
    }
</style>
